import { Y42FeatureType } from '@y42/json-schema';
import { FeatureRecord } from '../models/abstract-feature-entity-state.model';

export enum Noun {
  Singular = 'singular',
  Plural = 'plural',
}

export interface FeatureTypeLabel {
  [Noun.Singular]: string;
  [Noun.Plural]?: string;
}

// No-op function, just helps with strict typing
const makeFeatureTypeLabels = <T extends FeatureRecord<FeatureTypeLabel>>(obj: T) => obj;

export const Y42FeatureTypeToLabel = makeFeatureTypeLabels({
  [Y42FeatureType.Integration]: {
    [Noun.Singular]: 'Integration',
    [Noun.Plural]: 'Integrations',
  },
  [Y42FeatureType.UiModel]: {
    [Noun.Singular]: 'UI-Model',
    [Noun.Plural]: 'UI-Models',
  },
  [Y42FeatureType.SqlModel]: {
    [Noun.Singular]: 'SQL-Model',
    [Noun.Plural]: 'SQL-Models',
  },
  [Y42FeatureType.Orchestration]: {
    [Noun.Singular]: 'Orchestration',
    [Noun.Plural]: 'Orchestrations',
  },
  [Y42FeatureType.VisualizationDashboard]: {
    [Noun.Singular]: 'Dashboard',
    [Noun.Plural]: 'Dashboards',
  },
  [Y42FeatureType.VisualizationWidget]: {
    [Noun.Singular]: 'Widget',
    [Noun.Plural]: 'Widgets',
  },
  [Y42FeatureType.VisualizationFilter]: {
    [Noun.Singular]: 'Filter',
    [Noun.Plural]: 'Filters',
  },
  [Y42FeatureType.VisualizationTheme]: {
    [Noun.Singular]: 'Theme',
    [Noun.Plural]: 'Themes',
  },
  [Y42FeatureType.Export]: {
    [Noun.Singular]: 'Data Export',
    [Noun.Plural]: 'Data Exports',
  },
  [Y42FeatureType.StatusAlert]: {
    [Noun.Singular]: 'Alert',
    [Noun.Plural]: 'Alerts',
  },
  [Y42FeatureType.Lineage]: {
    [Noun.Singular]: 'Lineage',
    [Noun.Plural]: 'Lineage',
  },
  [Y42FeatureType.Catalog]: {
    [Noun.Singular]: 'Catalog',
    [Noun.Plural]: 'Catalog',
  },
} as const);

export const Y42FeatureTypeToChildLabel = makeFeatureTypeLabels({
  [Y42FeatureType.Integration]: {
    [Noun.Singular]: 'Table',
    [Noun.Plural]: 'Tables',
  },
  [Y42FeatureType.UiModel]: {
    [Noun.Singular]: 'Table',
    [Noun.Plural]: 'Tables',
  },
  [Y42FeatureType.SqlModel]: {
    [Noun.Singular]: 'Table',
    [Noun.Plural]: 'Tables',
  },
  [Y42FeatureType.VisualizationDashboard]: {
    [Noun.Singular]: 'Tab',
    [Noun.Plural]: 'Tabs',
  },
  [Y42FeatureType.Export]: {
    [Noun.Singular]: 'Trigger',
    [Noun.Plural]: 'Triggers',
  },
  [Y42FeatureType.Orchestration]: {
    [Noun.Singular]: '',
    [Noun.Plural]: '',
  },
  [Y42FeatureType.VisualizationWidget]: {
    [Noun.Singular]: '',
    [Noun.Plural]: '',
  },
  [Y42FeatureType.VisualizationFilter]: {
    [Noun.Singular]: '',
    [Noun.Plural]: '',
  },
  [Y42FeatureType.VisualizationTheme]: {
    [Noun.Singular]: '',
    [Noun.Plural]: '',
  },
  [Y42FeatureType.StatusAlert]: {
    [Noun.Singular]: '',
    [Noun.Plural]: '',
  },
  [Y42FeatureType.Lineage]: {
    [Noun.Singular]: '',
    [Noun.Plural]: '',
  },
  [Y42FeatureType.Catalog]: {
    [Noun.Singular]: '',
    [Noun.Plural]: '',
  },
} as const);
